// used in the blog-1 block
export const blogList1 = [
  {
    id: 1,
    category: 'Coding',
    date: '14 Apr 2022',
    image: '/img/photos/b4.jpg',
    title: 'Ligula tristique quis risus'
  },
  {
    id: 2,
    category: 'Workspace',
    date: '29 Mar 2022',
    image: '/img/photos/b5.jpg',
    title: 'ullam id dolor elit id nibh'
  },
  {
    id: 3,
    category: 'Meeting',
    date: '26 Feb 2022',
    image: '/img/photos/b6.jpg',
    title: 'Ultricies fusce porta elit'
  },
  {
    id: 4,
    category: 'Business Tips',
    date: '7 Jan 2022',
    image: '/img/photos/b7.jpg',
    title: 'Morbi leo risus porta eget'
  }
];

// used in the blog-3, blog-4 block
export const blogList2 = [
  {
    id: 1,
    category: 'Coding',
    date: '14 Apr 2022',
    image: '/img/photos/b4.jpg',
    title: 'Ligula tristique quis risus'
  },
  {
    id: 2,
    category: 'Workspace',
    date: '29 Mar 2022',
    image: '/img/photos/b5.jpg',
    title: 'ullam id dolor elit id nibh'
  },
  {
    id: 3,
    category: 'Meeting',
    date: '26 Feb 2022',
    image: '/img/photos/b6.jpg',
    title: 'Ultricies fusce porta elit'
  },
  {
    id: 4,
    category: 'Business Tips',
    date: '7 Jan 2022',
    image: '/img/photos/b7.jpg',
    title: 'Morbi leo risus porta eget'
  }
];

// used in the blog-5 block
export const blogList3 = [
  {
    id: 1,
    link: '#',
    comments: 4,
    category: 'Wedding',
    createdAt: '14 Apr 2022',
    title: 'Ligula tristique quis risus',
    image: { '1x': '/img/photos/b12.jpg', '2x': '/img/photos/b12@2x.jpg 2x' }
  },
  {
    id: 2,
    link: '#',
    comments: 3,
    category: 'Engagement',
    createdAt: '29 Mar 2022',
    title: 'Ligula tristique quis risus',
    image: { '1x': '/img/photos/b13.jpg', '2x': '/img/photos/b13@2x.jpg 2x' }
  },
  {
    id: 3,
    link: '#',
    comments: 6,
    category: 'Couples',
    createdAt: '26 Feb 2022',
    title: 'Ultricies fusce porta elit',
    image: { '1x': '/img/photos/b14.jpg', '2x': '/img/photos/b14@2x.jpg 2x' }
  },
  {
    id: 4,
    link: '#',
    comments: 3,
    category: 'Engagement',
    createdAt: '17 Jan 2022',
    title: 'Morbi leo risus porta eget',
    image: { '1x': '/img/photos/b15.jpg', '2x': '/img/photos/b15@2x.jpg 2x' }
  },
  {
    id: 5,
    link: '#',
    comments: 1,
    category: 'Couples',
    createdAt: '7 Jan 2022',
    title: 'Nulla vitae elit libero',
    image: { '1x': '/img/photos/b16.jpg', '2x': '/img/photos/b16@2x.jpg 2x' }
  },
  {
    id: 6,
    link: '#',
    comments: 2,
    category: 'Wedding',
    createdAt: '2 Jan 2022',
    title: 'Pharetra augue elit sem',
    image: { '1x': '/img/photos/b17.jpg', '2x': '/img/photos/b17@2x.jpg 2x' }
  }
];

// used in the blog-6 block
export const blogList4 = [
  {
    id: 1,
    link: '#',
    category: 'Roadtrip',
    image: '/img/photos/tb10.jpg',
    title: 'Ligula tristique quis risus',
    description: `Mauris convallis non ligula non interdum. Gravida vulputate convallis tempus vestibulum cras imperdiet nun eu dolor. Aenean lacinia bibendum nulla sed.`
  },
  {
    id: 2,
    link: '#',
    category: 'Historic',
    image: '/img/photos/tb11.jpg',
    title: 'Nullam id dolor elit id nibh',
    description: `Mauris convallis non ligula non interdum. Gravida vulputate convallis tempus vestibulum cras imperdiet nun eu dolor. Aenean lacinia bibendum nulla sed.`
  },
  {
    id: 3,
    link: '#',
    category: 'Cities',
    image: '/img/photos/tb12.jpg',
    title: 'Ultricies fusce porta elit',
    description: `Mauris convallis non ligula non interdum. Gravida vulputate convallis tempus vestibulum cras imperdiet nun eu dolor. Aenean lacinia bibendum nulla sed.`
  },
  {
    id: 4,
    link: '#',
    category: 'Beaches',
    image: '/img/photos/tb13.jpg',
    title: 'Morbi leo risus porta eget',
    description: `Mauris convallis non ligula non interdum. Gravida vulputate convallis tempus vestibulum cras imperdiet nun eu dolor. Aenean lacinia bibendum nulla sed.`
  }
];

// used in the hero-25 block
export const blogList5 = [
  {
    id: 1,
    comments: 3,
    author: 'SEOptimist',
    category: 'Places',
    createdAt: '8 Aug 2022',
    image: '/img/photos/tb1.jpg',
    title: 'The Best Moments in Venice'
  },
  {
    id: 2,
    comments: 5,
    author: 'SEOptimist',
    category: 'Restaurants',
    createdAt: '5 Jul 2022',
    image: '/img/photos/tb2.jpg',
    title: '10 Great Places in Belgium'
  },
  {
    id: 3,
    comments: 8,
    author: 'SEOptimist',
    category: 'Roadtrip',
    createdAt: '23 Jun 2022',
    image: '/img/photos/tb3.jpg',
    title: 'A Dreamy Roadtrip in Australia'
  },
  {
    id: 4,
    comments: 9,
    author: 'SEOptimist',
    category: 'Historic',
    createdAt: '15 Apr 2022',
    image: '/img/photos/tb4.jpg',
    title: 'My Love Affair with Cappadocia'
  },
  {
    id: 5,
    comments: 11,
    author: 'SEOptimist',
    category: 'Nature',
    createdAt: '14 Feb 2022',
    image: '/img/photos/tb5.jpg',
    title: '24 Hours in a Village of Valencia'
  },
  {
    id: 6,
    comments: 8,
    author: 'SEOptimist',
    category: 'Architecture',
    createdAt: '22 Jan 2022',
    image: '/img/photos/tb6.jpg',
    title: 'The Largest Train Station in Europe'
  },
  {
    id: 7,
    comments: 14,
    author: 'SEOptimist',
    category: 'Nature',
    createdAt: '2 Jan 2022',
    image: '/img/photos/tb7.jpg',
    title: 'The Natural Places in Brazil'
  }
];
